<template>
  <div :class="`${prefixClass}-calendar ${prefixClass}-calendar-panel-month`">
    <div :class="`${prefixClass}-calendar-header`">
      <sButton
        v-if="!hideDoubleArrows"
        :class="`${prefixClass}-calendar-btn-icon-double-left`"
        :disabled="isDisabledArrows('last-year')"
        icon="double-arrow"
        icon-size="10px"
        small
        type="text"
        @click="handleIconDoubleLeftClick"/>
      <sButton
        v-if="!hideDoubleArrows"
        :class="`${prefixClass}-calendar-btn-icon-double-right`"
        :disabled="isDisabledArrows('next-year')"
        icon="double-arrow"
        icon-class="s-svg-icon-rotate-180"
        icon-size="10px"
        small
        type="text"
        @click="handleIconDoubleRightClick"/>
      <span :class="`${prefixClass}-calendar-header-label`">
        <sButton
          small
          type="text"
          @click="handlePanelChange">
          {{ calendarYear }}
        </sButton>
      </span>
    </div>
    <div :class="`${prefixClass}-calendar-content`">
      <table
        :class="`${prefixClass}-table ${prefixClass}-table-month`"
        @click="handleClick">
        <tr
          v-for="(row, i) in months"
          :key="i">
          <td
            v-for="(cell, j) in row"
            :key="j"
            class="cell"
            :class="getCellClasses(cell.month)"
            :data-month="cell.month">
            <div>{{ cell.text }}</div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { getLocale } from 'toolkit/components/dateComponents/locale'
import { chunk, setYear } from 'toolkit/utils/date'

export default {
  name: 'sTableMonth',
  inject: {
    /*getLocale: {
      default: () => getLocale,
    },*/
    prefixClass: {
      default: 's-datepicker',
    },
    hideDoubleArrows: {
      type: Boolean,
      default: false,
    },
  },
  props: {
    disabledCalendarChanger: {
      type: Function,
      default: () => false,
    },
    calendar: {
      type: Date,
      default: () => new Date(),
    },
    getCellClasses: {
      type: Function,
      default: () => [],
    },
  },
  computed: {
    calendarYear() {
      return this.calendar.getFullYear()
    },
    months() {
      const locale = getLocale(this.$i18n.locale)

      const monthsLocale = locale.months || locale.formatLocale.monthsShort
      const months = monthsLocale.map((text, month) => {
        return { text, month }
      })

      return chunk(months, 3)
    },
  },
  methods: {
    isDisabledArrows(type) {
      const date = new Date(this.calendar)
      switch (type) {
      case 'last-year':
        date.setFullYear(date.getFullYear() - 1, 11, 31)
        date.setHours(23, 59, 59, 999)
        break
      case 'next-year':
        date.setFullYear(date.getFullYear() + 1, 0, 1)
        break
      default:
        break
      }
      return this.disabledCalendarChanger(date, type)
    },
    handleIconDoubleLeftClick() {
      this.$emit(
        'changecalendar',
        setYear(this.calendar, v => v - 1),
        'last-year'
      )
    },
    handleIconDoubleRightClick() {
      this.$emit(
        'changecalendar',
        setYear(this.calendar, v => v + 1),
        'next-year'
      )
    },
    handlePanelChange() {
      this.$emit('changepanel', 'year')
    },
    handleClick(evt) {
      let { target } = evt
      if (target.tagName.toUpperCase() === 'DIV') {
        target = target.parentNode
      }
      const month = target.getAttribute('data-month')
      if (month && !target.classList.contains('disabled')) {
        this.$emit('select', parseInt(month, 10))
      }
    },
  },
}
</script>
<style lang="scss">
@import 'toolkit/style/dateComponents/index.scss';
</style>
